/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Inputs for recording a savings ledger row from a rate-update rebook. The handler loads both stays, classifies the SavingsType from old.booking_agent + price comparison, and writes one ledger row. Both hotel stays must belong to the requesting user.
 * @export
 * @interface RecordHotelRateUpdateSavingsRequest
 */
export interface RecordHotelRateUpdateSavingsRequest {
    /**
     * Hotel stay being replaced (carries the original total_cost / currency / booking_agent).
     * @type {string}
     * @memberof RecordHotelRateUpdateSavingsRequest
     */
    oldHotelStayId: string;
    /**
     * Newly created hotel stay (carries the new total_cost and the linked Gondola booking_id).
     * @type {string}
     * @memberof RecordHotelRateUpdateSavingsRequest
     */
    newHotelStayId: string;
    /**
     * Distinguishes auto-save (system-initiated, may produce auto_save_internal/external/boost) from user-initiated (produces rate_update_internal/external).
     * @type {string}
     * @memberof RecordHotelRateUpdateSavingsRequest
     */
    trigger: RecordHotelRateUpdateSavingsRequestTriggerEnum;
}


/**
 * @export
 */
export const RecordHotelRateUpdateSavingsRequestTriggerEnum = {
    AutoSave: 'auto_save',
    UserInitiated: 'user_initiated'
} as const;
export type RecordHotelRateUpdateSavingsRequestTriggerEnum = typeof RecordHotelRateUpdateSavingsRequestTriggerEnum[keyof typeof RecordHotelRateUpdateSavingsRequestTriggerEnum];


/**
 * Check if a given object implements the RecordHotelRateUpdateSavingsRequest interface.
 */
export function instanceOfRecordHotelRateUpdateSavingsRequest(value: object): value is RecordHotelRateUpdateSavingsRequest {
    if (!('oldHotelStayId' in value) || value['oldHotelStayId'] === undefined) return false;
    if (!('newHotelStayId' in value) || value['newHotelStayId'] === undefined) return false;
    if (!('trigger' in value) || value['trigger'] === undefined) return false;
    return true;
}

export function RecordHotelRateUpdateSavingsRequestFromJSON(json: any): RecordHotelRateUpdateSavingsRequest {
    return RecordHotelRateUpdateSavingsRequestFromJSONTyped(json, false);
}

export function RecordHotelRateUpdateSavingsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecordHotelRateUpdateSavingsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'oldHotelStayId': json['old_hotel_stay_id'],
        'newHotelStayId': json['new_hotel_stay_id'],
        'trigger': json['trigger'],
    };
}

export function RecordHotelRateUpdateSavingsRequestToJSON(json: any): RecordHotelRateUpdateSavingsRequest {
    return RecordHotelRateUpdateSavingsRequestToJSONTyped(json, false);
}

export function RecordHotelRateUpdateSavingsRequestToJSONTyped(value?: RecordHotelRateUpdateSavingsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'old_hotel_stay_id': value['oldHotelStayId'],
        'new_hotel_stay_id': value['newHotelStayId'],
        'trigger': value['trigger'],
    };
}

